var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-item',{attrs:{"title":_vm.caption,"data-source":_vm.dataSource,"breadcrumbs":_vm.breadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }